import React from 'react';
import { Col } from 'reactstrap';
import { H3 } from '../../../../AbstractElements';

export function Feedback() {
    return (
        <div className='container-fluid'>
            <div className="table-responsive h-100 py-4">
                <section className='bg-white'>
                    <div className="scrollable-table-container">
                        <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                            <div className="d-flex align-items-center">
                                <Col xs={12} className='d-flex'>
                                    <H3 className="heading-color f-w-900 text-left my-2">Feedback</H3>
                                </Col>
                            </div>
                            <div className="text-center">
                                <div className="d-flex justify-content-center my-4">
                                    <span role="img" aria-label="Happy" style={{ fontSize: '80px', margin: '0 10px' }}>😊</span>
                                    <span role="img" aria-label="Neutral" style={{ fontSize: '80px', margin: '0 10px' }}>😐</span>
                                    <span role="img" aria-label="Sad" style={{ fontSize: '80px', margin: '0 10px' }}>😢</span>
                                </div>
                                <h2 className="text-primary" style={{ fontSize: '30px' }}>FEEDBACK</h2>
                                <p style={{ fontSize: '18px' }}>We love the feedback from our clients that will make this software even better.</p>
                                <p style={{ fontSize: '18px' }}>So if you have found a bug or have a suggestion please email</p>
                                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=help@fintrack.com.au" target="_blank" rel="noopener noreferrer" className="text-primary" style={{ fontSize: '18px' }}>help@fintrack.com.au</a>
                                <p style={{ fontSize: '18px' }}>Thank you</p>
                                <footer className="mt-4">
                                    <p style={{ fontSize: '16px', color: '#007bff' }}>© Copyright Fintrack Pty Ltd ACN 006 164 709. All rights reserved.</p>
                                </footer>
                            </div>

                        </table>
                    </div>
                </section>
            </div>
        </div>
    );
}